import { render, staticRenderFns } from "./EventConfig.vue?vue&type=template&id=50da71f4&scoped=true&"
import script from "./EventConfig.vue?vue&type=script&lang=js&"
export * from "./EventConfig.vue?vue&type=script&lang=js&"
import style0 from "./EventConfig.vue?vue&type=style&index=0&id=50da71f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da71f4",
  null
  
)

export default component.exports